<template>
  <div class="ui-fas">
    <el-input v-model="name" @input.native="filterIcons" class="iconpicker-search" suffix-icon="el-icon-search" placeholder="请输入图标名称"></el-input>
    <ul class="fas-icon-list">
      <li v-for="(item, index) in iconList" :key="index" v-on:mouseover="changeActive($event)" v-on:mouseout="removeActive($event)" @click="selectedIcon(item)" class="iconpicker-icon-item">
        <svg-icon class="fas-icon" :icon-class="item" ></svg-icon>
      </li>
    </ul>
  </div>
</template>
<script>
  import fontawesome from '@/store/solid.js'
  import SvgIcon from "../SvgIcon/index";
  export default {
    components: {SvgIcon},
    name: 'compIcons',
    data () {
      return {
        name: '',
        iconList: fontawesome
      }
    },
    methods: {
      changeActive($event){
        $event.currentTarget.className="iconpicker-icon-item active";
      },
      removeActive($event){
        $event.currentTarget.className="iconpicker-icon-item";
      },
      filterIcons () {
        if (this.name) {
          this.iconList = fontawesome.filter(item => item.includes(this.name))
        } else {
          this.iconList = fontawesome
        }
      },
      selectedIcon (name) {
        this.$emit('selected', name)
      },
      reset () {
        this.name = ''
        this.iconList = fontawesome
      }
    }
  }
</script>
<style>
  .ui-fas {
    padding:6px;
  }
  .iconpicker-search {
    position: relative;
    margin: 0 0 6px 0;
    border: 1px solid #e6e6e6;
    border-radius: 2px;
    transition: 300ms;
  }
  .fas-icon-list {
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: block;
    height: 200px;
    overflow-y: scroll;
  }
  .iconpicker-icon-item {
    display: inline-block;
    width: 21.1%;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    vertical-align: top;
    height: 36px;
    margin: 4px;
    border: 1px solid #ddd;
    border-radius: 2px;
    transition: 300ms;
  }

  .fas-icon {
    font-size: 17px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .iconpicker-icon-item:hover {
    background-color: #eee;
    border-color: #ccc;
    -webkit-box-shadow: 0 0 2px #aaa, 0 0 2px #fff inset;
    -moz-box-shadow: 0 0 2px #aaa,0 0 2px #fff inset;
    box-shadow: 0 0 2px #aaa, 0 0 2px #fff inset;
    text-shadow: 0 0 1px #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/IconPicker/iconPicker.vue